import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box, CircularProgress} from 'views/components';

import WeeklySlip from './WeeklySlip';
import MonthlySlip from './MonthlySlip';
import RegenerateInvoice from './RegenerateInvoice';
import RegenerateMonthlyInvoice from './RegenerateMonthlyInvoice';

const Payment = (props) => {
  const clientRn = props.clientRn;
  const refresh = props.refresh;
  const clientBackend = props.clientBackend;
  const clientPaymentSlipWeekly = props.clientPaymentSlipWeekly;
  const clientPaymentSlipMonthly = props.clientPaymentSlipMonthly;
  const clientPaymentSlipLoading = props.clientPaymentSlipLoading;
  const clientPaymentPlan = props.clientPaymentPlan;

  React.useEffect(() => {
    clientBackend.payment.loadPaymentSlips();
  }, [clientRn, refresh]);

  if (clientPaymentSlipLoading) {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: 2,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Only the client's CURRENT billing period's section shows -- a client that switched
  // WEEKLY<->MONTHLY doesn't get a confusing mixed list of both domains.
  const isMonthly = clientPaymentPlan?.billingPeriod === 'MONTHLY';

  if (isMonthly) {
    return (
      <Stack
        sx={{
          p: 2,
        }}
        spacing={1}
      >
        <RegenerateMonthlyInvoice clientBackend={clientBackend} />
        {
          clientPaymentSlipMonthly.map((e) => {
            return (
              <MonthlySlip
                key={e.monthOf}
                slipDetail={e}
                clientBackend={clientBackend}
              />
            );
          })
        }
      </Stack>
    );
  }

  return (
    <Stack
      sx={{
        p: 2,
      }}
      spacing={1}
    >
      <RegenerateInvoice clientBackend={clientBackend} />
      {
        clientPaymentSlipWeekly.map((e) => {
          return (
            <WeeklySlip
              key={e.weekOf}
              slipDetail={e}
              clientBackend={clientBackend}
            />
          );
        })
      }
    </Stack>
  );
};

Payment.propTypes = {
  refresh: PropTypes.number.isRequired,
  clientRn: PropTypes.string.isRequired,
  clientBackend: PropTypes.object.isRequired,
  clientPaymentSlipWeekly: PropTypes.array.isRequired,
  clientPaymentSlipMonthly: PropTypes.array.isRequired,
  clientPaymentSlipLoading: PropTypes.bool.isRequired,
  clientPaymentPlan: PropTypes.object,
};
export default React.memo(Payment);
